export default __webpack_public_path__ + "static/media/icon_support_dashboard.592bc20a.svg";